import { useCallback, useState } from 'react';

import CameraConnection from 'src/models/Camera/CameraConnection';
import { GetLanguagesResponse } from 'src/models/Camera/Settings/Language/GetLanguages.model';

import { captureError } from 'src/utils/errorReporting';

export function useGetCameraLanguages() {
  const [languages, setLanguages] = useState<GetLanguagesResponse>();

  const [isGettingLanguages, setIsGettingLanguages] = useState(false);

  const getCameraLanguages = useCallback(async () => {
    try {
      setIsGettingLanguages(true);
      const response = await CameraConnection.getInstance().getLanguages();
      setLanguages(response.data);
    } catch (error) {
      captureError(error, 'Failed to get camera languages');
    } finally {
      setIsGettingLanguages(false);
    }
  }, []);

  return {
    getCameraLanguages,
    isGettingLanguages,
    languages,
  };
}
